import React from 'react'
import './Discover.css';
import Background from "../images/image74.jpg"
import cart1 from "../images/png/image49.png"
import cart2 from "../images/png/image32.png"
import cart3 from "../images/png/Rectangle166.png"
import cart4 from "../images/png/image24.png"

const Discover=()=>{

  return (
    <div>
        <div className='discover' style={{backgroundImage:`url(${Background})`,height:"50vh"}}>
            <div className='subdiscober'>
                <p>DISCOVER</p>
                <h1>GRAPHIC DESIGN IDEAS <br/> AND SERVICES</h1>
                <h4>FORM BRANDING TO MARKETING</h4>
                <input type="text" placeholder='what kind of design you are looking for ?'/>
                <button type="submit">Search</button>
            </div>
            <div className='cart1'>
              <h5 className='l1'></h5>
              <img src={cart1} alt=""/>  
            </div>
            <div className='cart2'>
              <h3 className='l2'></h3>
              <img src={cart2} alt=""/>  
            </div>
            <div className='cart3'>
              <h3 className='l3'></h3>
              <img src={cart3} alt=""/>  
            </div>
            <div className='cart1'>
              <h3 className='l1'></h3>
              <img src={cart4} alt=""/>  
            </div>
        </div>
        <div className='popular'>
          <p><span>Popular:</span>  Website Design Logo Design Brochure Label Design</p>
        </div>
    </div>
  )
}
export {Discover}
